import { useQuery } from '@tanstack/react-query';
import { useSession } from '@/lib/session';
import { fetchInbox, notificationKeys } from './api';

/** Shared cache keeps the header and navigation counts in sync for the active role. */
export function useNotificationFeed(platform = false) {
  const { user, principal } = useSession();
  const queryKey = [...notificationKeys.bell, platform, user?.id, principal?.tenantId, principal?.kind, principal?.clientId, principal?.participantId, principal?.role];
  const query = useQuery({
    queryKey,
    queryFn: ({ signal }) => fetchInbox({ limit: 10, signal, platform }),
    enabled: platform ? user?.platformRole === 'platform_operator' : !!principal,
    refetchInterval: 5_000,
    staleTime: 4_000,
    refetchOnWindowFocus: 'always',
  });
  return { ...query, queryKey };
}

export function NotificationNavBadge({ platform = false }: { platform?: boolean }) {
  const { data } = useNotificationFeed(platform);
  const unread = data?.unread ?? 0;
  return unread > 0 ? <span className="nav-badge" aria-label={`${unread} unread notifications`}>{unread > 99 ? '99+' : unread}</span> : null;
}
